import React from 'react';
import { Image } from 'elements';
import strings from '../../../../utils/translationStrings';

import './FeaturesSection.scss';

export const FeaturesSection = () => {
  return (
    <section id="features" className="features">
      <div className="features__container">
        <div className="features__row">
          <div className="feature feature__main">

            <div className="feature__container">
              <Image
                height="218px"
                width="40%"
                source="/resources/images/assets/cart.svg"
              />
              <div className="feature-details">
                <h3 className="feature-details__title">{strings.landing.features.main.title}</h3>
                <p className="feature-details__description">{strings.landing.features.main.description}</p>
              </div>
            </div>

          </div>
          <div className="feature feature__sell">

            <div className="feature__container">
              <Image
                height="218px"
                width="40%"
                source="/resources/images/assets/sell_everywhere.svg"
              />
              <div className="feature-details">
                <h3 className="feature-details__title">{strings.landing.features.sell.title}</h3>
                <p className="feature-details__description">{strings.landing.features.sell.description}</p>
              </div>
            </div>

          </div>
        </div>
        <div className="features__row">
          <div className="feature feature__coverage">

            <div className="feature__container">
              <Image
                height="218px"
                width="40%"
                source="/resources/images/assets/global_coverage.svg"
              />
              <div className="feature-details">
                <h3 className="feature-details__title">{strings.landing.features.coverage.title}</h3>
                <p className="feature-details__description">{strings.landing.features.coverage.description}</p>
              </div>
            </div>

          </div>
          <div className="feature feature__support">

            <div className="feature__container">
              <Image
                height="218px"
                width="40%"
                source="/resources/images/assets/get_your_help.svg"
              />
              <div className="feature-details">
                <h3 className="feature-details__title">{strings.landing.features.support.title}</h3>
                <p className="feature-details__description">{strings.landing.features.support.description}</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/containers/Landing/Partial/FeaturesSection/FeaturesSection.js